import { useHistory } from "react-router-dom";

import IcComplaintServiceMain from "../../assets/svg/IcComplaintServiceMain.svg";
import IcComplaintServiceMainMobile from "../../assets/svg/IcComplaintServiceMainMobile.svg";
import IcComplaintServiceBody from "../../assets/svg/IcComplaintServiceBody.svg";
import IcComplaintServiceBodyMobile from "../../assets/svg/IcComplaintServiceBodyMobile.svg";
import IcComplaintServiceBody2 from "../../assets/svg/IcComplaintServiceBody2.svg";
import IcComplaintServiceBody2Mobile from "../../assets/svg/IcComplaintServiceBody2Mobile.svg";

import {
  Container,
} from "../Service.style";
import {
  ServiceCenterFirstContainer,
  ServiceCenterFirstImg,
  ServiceCenterFirstSection,
  ServiceCenterFirstTitle,
  ServiceCenterFooterBtn,
  ServiceCenterFooterContainer,
  ServiceCenterFooterDesc,
  ServiceCenterFooterSection,
  ServiceCenterFooterTextContainer,
  ServiceCenterFooterTitle,
  ServiceCenterSecondContainer,
  ServiceCenterSecondDesc,
  ServiceCenterSecondImg,
  ServiceCenterSecondSection,
  ServiceCenterSecondSubTitle,
  ServiceCenterSecondTextContainer,
  ServiceCenterSecondTitle,
  ServiceCenterThirdContainer,
  ServiceCenterThirdDesc,
  ServiceCenterThirdDescSpan,
  ServiceCenterThirdImg,
  ServiceCenterThirdImgMobile,
  ServiceCenterThirdSection,
  ServiceCenterThirdTextContainer,
  ServiceCenterThirdTitle
} from "./ServiceCenter.style";
import Footer from "components/Footer";
import { useEffect } from "react";
import ChannelService from "../ChannelService";
import { removeBrTag } from "routes/Landing";

const ComplaintServiceCenter = ({ loggedInUser }) => {
  const history = useHistory();

  const isMobile = window.matchMedia("(max-width: 768px)").matches;

  const title = () => {
    const text = "고소장 작성하기";
    return removeBrTag(text);
  };

  const body1Title = () => {
    const text = isMobile
      ? "형사 고소의 시작,\n고소장 작성하기"
      : "형사 고소의 시작, 고소장 작성하기";
    return removeBrTag(text);
  };

  const body1Subtitle = () => {
    const text = isMobile
      ? "필수적 이지만, 어려운"
      : "필수적 이지만, 어려운 작성법";
    return removeBrTag(text);
  };

  const body2Title = () => {
    const text = isMobile
      ? "고소장 작성은\n법대리에게!"
      : "고소장 작성은 법대리에게!";
    return removeBrTag(text);
  };

  const footerTitle = () => {
    const text = isMobile
      ? "고소장 작성이\n필요하신가요?"
      : "고소장 작성이 필요하신가요?";
    return removeBrTag(text);
  };


  const onClickBtn = () => {
    history.push("/loan/order");
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Container>
      <ServiceCenterFirstSection>
        <ServiceCenterFirstContainer>
          <picture>
            <source
              media="(max-width: 768px)"
              srcSet={IcComplaintServiceMainMobile}
            />
            <source
              media="(min-width: 768px)"
              srcSet={IcComplaintServiceMain}
            />
            <ServiceCenterFirstImg src={IcComplaintServiceMain} />
          </picture>
          <ServiceCenterFirstTitle>
            {title()}
          </ServiceCenterFirstTitle>
        </ServiceCenterFirstContainer>
      </ServiceCenterFirstSection>
      <ServiceCenterSecondSection>
        <ServiceCenterSecondContainer>
          <ServiceCenterSecondTextContainer>
            <ServiceCenterSecondTitle>{body1Title()}</ServiceCenterSecondTitle>
            <ServiceCenterSecondSubTitle>
              {body1Subtitle()}
            </ServiceCenterSecondSubTitle>
            <ServiceCenterSecondDesc>
              온/오프라인에서 사기, 명예훼손, 모욕 등의 피해를 입었을 때 가해자의 형사 처벌을 위해서는 고소장 작성 및 경찰 제출을 필수적으로 해야합니다.
              하지만 법을 모르는 일반인이 상대방을 처벌 받게 할 수 있는 제대로 된 고소장을 쓰기는 쉽지 않습니다.
              고소장을 제대로 작성하지 않으면 경찰서에서 고소장을 반려하는 경우도 굉장히 많습니다.
            </ServiceCenterSecondDesc>
          </ServiceCenterSecondTextContainer>
          <picture>
            <source
              media="(max-width: 768px)"
              srcSet={IcComplaintServiceBodyMobile}
            />
            <source
              media="(min-width: 768px)"
              srcSet={IcComplaintServiceBody}
            />
            <ServiceCenterSecondImg src={IcComplaintServiceBody} />
          </picture>
        </ServiceCenterSecondContainer>
      </ServiceCenterSecondSection>
      <ServiceCenterThirdSection>
        <ServiceCenterThirdContainer>
          <ServiceCenterThirdImg src={IcComplaintServiceBody2} />
          <ServiceCenterThirdTextContainer>
            <ServiceCenterThirdTitle>
              {body2Title()}
            </ServiceCenterThirdTitle>
            <ServiceCenterThirdDesc>
              가해자의 확실한 처벌을 위해서는 형사 전문 변호사가 정식으로 작성한 고소장을 제출해야 합니다.
              법대리는 기존 큰 비용이 드는 변호사 선임의 부담을 없애고, 가장 저렴한 가격에 사기, 명예훼손, 모욕, 통매음 등
              각 분야의 형사전문변호사가 직접 쓴 양질의 고소장을 받아볼 수 있는 서비스를 제공하고 있습니다.
            </ServiceCenterThirdDesc>
          </ServiceCenterThirdTextContainer>
          <ServiceCenterThirdImgMobile src={IcComplaintServiceBody2Mobile} />
        </ServiceCenterThirdContainer>
      </ServiceCenterThirdSection>
      <ServiceCenterFooterSection>
        <ServiceCenterFooterContainer>
          <ServiceCenterFooterTextContainer>
            <ServiceCenterFooterTitle>
              {footerTitle()}
            </ServiceCenterFooterTitle>
            <ServiceCenterFooterDesc>
              현재 겪고 계신 법률 문제와 해결하고 싶은 문제를 제출 해주시면
              분야별로 가장 경험이 많고 실력있는 담당 변호사들이 검토 후 안내연락을 무료로 드립니다.
            </ServiceCenterFooterDesc>
          </ServiceCenterFooterTextContainer>
          <ServiceCenterFooterBtn onClick={() => history.push("/apply/complaintService")}>
            내용 증명 보내기
          </ServiceCenterFooterBtn>
        </ServiceCenterFooterContainer>
      </ServiceCenterFooterSection>
    </Container>
  )
};

export default ComplaintServiceCenter;
